import { render, staticRenderFns } from "./AddAssetComponent.vue?vue&type=template&id=f1a94fc2&"
import script from "./AddAssetComponent.vue?vue&type=script&lang=js&"
export * from "./AddAssetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports